
import React from 'react';
import { priceFormatterV3 } from '../../settings/themeSettings';
import './DashboardTable.scss';
import './percentage-fix.css';

const DashboardTable = ({ caption, data, title }) => {

    return <table className='dashboard-table'>
        <caption> {caption} </caption>
        {title && <thead>
            <tr>
                <th></th>
                {title.map((tl, idx) => <th key={idx}>{tl}</th>)}
            </tr>
        </thead>}
        <tbody>
            {
                data.map((item, idx) => <tr key={idx}>
                    <td>{item.title}</td>
                    {Array.isArray(item.value) ? 
                        item.value.map((v, key) => {
                            // Détection simple et sûre des pourcentages
                            const isPercentage = typeof v === 'string' && v.includes('%');
                            const cellStyle = {
                                textAlign: isPercentage ? 'center' : (isNaN(Number(v)) ? 'left' : 'right'),
                                ...(isPercentage && {
                                    fontWeight: 'bold',
                                    // backgroundColor: 'transparent',
                                    // backgroundImage: 'none'
                                })
                            };
                            
                            return (
                                <td key={key} style={cellStyle}>
                                    {priceFormatterV3(v)}
                                </td>
                            );
                        }) : 
                        (() => {
                            const value = item.value;
                            const isPercentage = typeof value === 'string' && value.includes('%');
                            const cellStyle = {
                                textAlign: isPercentage ? 'center' : (isNaN(Number(value)) ? 'left' : 'right'),
                                ...(isPercentage && {
                                    fontWeight: 'bold',
                                    // backgroundColor: 'transparent',
                                    // backgroundImage: 'none'
                                })
                            };
                            
                            return (
                                <td style={cellStyle}>
                                    {priceFormatterV3(value)}
                                </td>
                            );
                        })()
                    }
                </tr>

                )
            }
        </tbody>

    </table>;
}

export default DashboardTable;